import { fetchWrapper, handleResponse, hcUrlV3, buildOpts } from 'services/RequestService/helpers';

export const getMealReviewStats = async ({ params: { mealId, menuSlug } }) => {
  const response = await fetchWrapper(
    hcUrlV3(`/menus/${menuSlug}/meals/${mealId}/review_stats`),
    buildOpts()
  );

  return handleResponse(response);
};
